import React from 'react';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-types-papi';
import MiniProfileIdentity from '../_partials/MiniProfileIdentity';
import ElementQueries from '@wix/da-shared-react/pkg/ElementQueries';

import s from './Admins.scss';

export type AdminRoleType = {
  typeId: number;
  name: string;
};

export type ResultItem = {
  typeId: number;
  user: PapiUser;
};

export interface Props {
  moduleId: number;
  isWide: boolean;
  seeAllUrl: string;
  browseUrl: string;
  roles: AdminRoleType[];
  results: ResultItem[];
  hasMore?: boolean;
  nextOffset?: number;
}

export const Admins: React.FC<Props> = ({ isWide, results, roles }) => {
  return (
    <div className={s['root']}>
      {roles.map(({ typeId, name }) => {
        const deviants = results
          .filter(result => result.typeId === typeId)
          .map(result => result.user);
        if (!deviants.length) {
          return null;
        }
        return (
          <div className={s['role-group']} key={typeId}>
            <h3 className={s['role-title']}>{name}</h3>
            <ElementQueries
              widthBreakpoints={[640, 800]}
              className={classnames(s['grid'], !isWide && s['grid-flex'])}
            >
              {deviants.map(deviant => (
                <MiniProfileIdentity
                  key={deviant.username}
                  className={s['member']}
                  user={deviant}
                  withTooltip
                />
              ))}
            </ElementQueries>
          </div>
        );
      })}
    </div>
  );
};
Admins.displayName = 'Admins';

export default Admins;
